import { getCountryCallingCode } from "libphonenumber-js";


// https://www.cloudflare.com/cdn-cgi/trace
export const getCountryISO = async () => {
  try {
    const response = await fetch("https://www.cloudflare.com/cdn-cgi/trace");
    const text = await response.text();
    const match = text.match(/^loc=(.*)$/m);
    return match ? match[1] : null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getCountryCode = async () => {
  try {
    const country = await getCountryISO();
    if (!country) {
      return null;
    }
    return `+${getCountryCallingCode(country)}`;
  } catch (error) {
    console.log(error);
    return null;
  }
};